module.exports = "/_next/static/images/macpunks-2-e42ca7cc56ce6666501b30bbdc34f440.png";